import React, { useEffect, useState } from "react";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons";
import { faHeading } from "@fortawesome/free-solid-svg-icons";
import { OptionsEditProps, QuestionDefinition, QuestionProps } from "../QuestionAnswer";
import { GroupContainer } from "../GroupContainer";
import { FormLabel, RawFormError, RawFormInput } from "../FormElements";
import { EnsureInputAnswer } from "consumerhouse-shared";
import { useLanguage } from "../../useLanguage";

export type EnsureInputQuestionOptions = {
    mustContain: string;
};

export const EnsureInputDefinition: QuestionDefinition = {
    icon: faCheckSquare,
    defaultOptions: {
        mustContain: "",
    } as EnsureInputQuestionOptions,
    questionComponent: EnsureInputQuestion,
    optionsEditComponent: EnsureInputQuestionEdit,
};

function EnsureInputQuestion(props: QuestionProps<EnsureInputQuestionOptions, EnsureInputAnswer>) {
    const [value, setValue] = useState(props.value?.input || "");
    const [matching, setMatching] = useState(true);
    const language = useLanguage();

    useEffect(() => {
        let m = value.trim().toLowerCase().includes(props.question.optionsJson!.mustContain.toLowerCase().trim());
        if (m) {
            props.onChange({ input: value });
        }
        setMatching(m);
    }, [value]);

    return (
        <div>
            <RawFormInput
                readOnly={props.readOnly}
                onChange={(ev) => {
                    let v = ev.target.value;
                    setValue(v);
                }}
                value={value}
            />
            {!matching && <RawFormError>{language("question-not-accepted")}</RawFormError>}
        </div>
    );
}

function EnsureInputQuestionEdit(props: OptionsEditProps<EnsureInputQuestionOptions>) {
    return (
        <GroupContainer title="Opties" color="#5a8ee8">
            <FormLabel>Moet bevatten</FormLabel>
            <RawFormInput onChange={(ev) => props.onChange({ mustContain: ev.target.value })} value={props.options?.mustContain || ""} />
        </GroupContainer>
    );
}
